function trackGoogleAdsConversion(): void {
  try {
    if (!window.dataLayer) {
      console.error(
        'Google Ads tracking unavailable: dataLayer not found (GTM not loaded)',
      )
      return
    }

    window.dataLayer.push({
      event: 'concierge_submitted',
      conversion_value: 1.0,
      currency: 'USD',
    })
    console.log('Lead form submit event pushed to dataLayer')
  } catch (error) {
    console.error('Failed to track conversion:', error)
  }
}

export { trackGoogleAdsConversion }
